import { ActivityParams } from './types';

export const activityKeys = {
  list: (params: ActivityParams) => ['ACTIVITY', { params }] as const,
};
